import { render, staticRenderFns } from "./color_group.vue?vue&type=template&id=7ce036fe&scoped=true"
import script from "./color_group.vue?vue&type=script&lang=ts"
export * from "./color_group.vue?vue&type=script&lang=ts"
import style0 from "./color_group.vue?vue&type=style&index=0&id=7ce036fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce036fe",
  null
  
)

export default component.exports